const { CanvasTextWrapper } = require('./utils')

const defaultOptions = {
    font: 'bold {size}px Arial, sans-serif',
    fontSize: 30,
    slogan: 'CaptionNerve.com',
    fontColor: 'white',
    lineWidth: 1.3,
    lineHeight: 1.5,
    setupText: '',
    punchlineText: '',
    footer: false,
    logo: null,
}

/**
 * Draw a footer 
 * 
 * @param {Context} ctx 
 * @param {String} slogan 
 */
const drawFooter = (ctx, { slogan, logo, width, height } = {}) => {
    ctx.fillStyle = '#fff'
    ctx.font = '12px Arial, sans-serif'
    ctx.baseline = 'bottom'
    ctx.textAlign = 'right'

    ctx.fillText(slogan, width - 10, height - 11)
    
    if (logo) {
        const sloganWidth = ctx.measureText(slogan).width
        ctx.drawImage(logo, width - (sloganWidth + 30), height - 23, 13, 15)
    }
}
exports.drawFooter = drawFooter

/**
 * Draw text
 * 
 * @param {Canvas} canvas
 * @param {String} text
 * @param {Object} options
 **/
const drawText = (canvas, text, opts = {}) => {
    const ctx = canvas.getContext('2d')

    let size = opts.fontSize
    const textWidth = ctx.measureText(text).width
    if (textWidth > canvas.width) {
        size = opts.fontSize * .8
    }

    // draw shadow
    ctx.fillColor = 'black'
    ctx.lineWidth = 1.5
    CanvasTextWrapper(canvas, text, {
        ...opts,
        font: opts.font.replace('{size}', size),
        paddingX: 5 + (opts.offsetX || 0),
        paddingY: 5 + (opts.offsetY || 0),
        lineHeight: 1.3,
        strokeText: true,
        renderHDPI: false,
    })
    // draw text
    ctx.fillStyle = opts.fontColor
    ctx.lineWidth = 1.4
    CanvasTextWrapper(canvas, text, {
        ...opts,
        font: opts.font.replace('{size}', size),
        paddingX: 5 + (opts.offsetX || 0),
        paddingY: 5 + (opts.offsetY || 0),
        lineHeight: 1.3,
        renderHDPI: false,
    })
}
    

/**
 * Create a caption for an image
 * 
 * @param {Canvas} canvas 
 * @param {Object} options 
 */
exports.drawMeme = async (canvas, options = defaultOptions) => {
    if (!canvas) {
        throw new Error('Canvas is required')
    }

    const opts = { ...defaultOptions, ...options }
    
    const ctx = canvas.getContext('2d')
    const dwt = drawText.bind(null, canvas)


    if (opts.footer) {
        const offset = 30
        opts.height = opts.height + offset

        canvas.width = opts.width
        canvas.height = opts.height

        ctx.fillStyle = '#000'
        ctx.fillRect(0, 0, opts.width, opts.height)
        ctx.drawImage(opts.image, 0, 0, opts.width, opts.height - offset)

        drawFooter(ctx, opts)
    }

    if (opts.setupText && opts.setupText.length) {
        dwt(opts.setupText.trim(), {
            font: opts.font,
            fontSize: opts.fontSize,
            fontColor: opts.fontColor,
            lineHeight: opts.lineHeight,
            textAlign: 'center',
            verticalAlign: 'top',
            offsetY: 6,
            offsetX: 10,
        })
    }

    if (opts.punchlineText && opts.punchlineText.length) {
        dwt(opts.punchlineText.trim(), {
            font: opts.font,
            fontSize: opts.fontSize,
            fontColor: opts.fontColor,
            lineHeight: opts.lineHeight,
            textAlign: 'center',
            verticalAlign: 'bottom',
            offsetY: 30,
            offsetX: 10,
        })
    }

    return canvas
}